module.exports = __webpack_public_path__ + "images/category_lp/watch/product-1_faabaf1f91e79606a584b651ff69bd24.jpg";